

export default {
  name: 'EmptyLayout',
};
